import React from 'react'
import ApiFetcher from 'lib/api_fetcher'
import crono from 'img/crono'
import {useTranslation} from 'react-i18next'

const PaymentRedirectCallout = ({cart, endpoint}) => {
  const { t, i18n } = useTranslation()

  if (cart && cart.status === 'payment_pending') {
    return (
      <div className="alert alert-info text-center" role="alert">
        <h3 className="alert-heading">
          <i className="fa fa-check text-success me-2" />
          {i18n.t('payment_redirect_callout.wait_few_seconds_title')}
        </h3>
        <p>{i18n.t('payment_redirect_callout.wait_few_seconds_description')}</p>
        <p><img width="150" height="150" src={crono} alt="Esperando pago" /></p>
      </div>
    )
  }

  return ''
}

export default PaymentRedirectCallout